<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="6000"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-layout mt-5>
      <v-flex xs12>
        <div :class="paginatedItems.length === 5 ? 'warrant_box' : 'warrant_box_empty'">
          <v-card-text>
            <v-layout>
              <v-flex xs3>
                <span class="accent--text" style="font-size: 14px; font-weight:700;"> Grower Payments </span>
              </v-flex>
              <v-spacer>
              </v-spacer>
              <v-flex xs3>
                <v-text-field label="Search" v-model="search">
                </v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-btn
                  color="primary"
                  @click="approveActionForSelected"
                >
                  Approve Selected
                </v-btn>
              </v-flex>
            </v-layout>
            <table class="table">
              <thead class="thead">
              <tr>
                <th scope="col"><input type="checkbox" v-model="selectAll" @change="selectAllItems" /></th>
                <th scope="col">Eslip</th>
                <th scope="col">LotNumber</th>
                <th scope="col">InvoiceId</th>
                <th scope="col">CleanCoffee</th>
                <th scope="col">Broker Code</th>
                <th scope="col">Amount</th>
                <th scope="col">Eslip Amount</th>
                <th scope="col">Grower Code</th>
                <th scope="col">DateCreated</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in filteredList" v-bind:key="item.id">
                <td v-if="canBeApproved1(item)">
                  <input type="checkbox" v-model="item.selected" @change="onCheckboxChange(item)" /></td>
                <td v-else>
                  <!-- Render an empty cell if the item doesn't meet the condition -->
                </td>
                <!-- <td><input type="checkbox" v-model="item.selected" @change="onCheckboxChange(item)" /></td> -->
                <td> {{ item.eslipNumber }} </td>
                <td> {{ item.lotNumber }} </td>
                <td> {{ item.invoiceId }} </td>
                <td> {{ item.cleanCoffeeOutTurn }} </td>
                <td> {{ item.brokerCode }} </td>
                <td> {{ item.nceAmount }}</td>
                <td> {{ item.eslipAmount }}</td>
                <td> {{ item.growerCode }}</td>
                <td> {{ item.dateCreated | prettyDate }}</td>
                <td class="actions">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="primary"
                        v-on="on"
                        text
                        icon
                        
                      >
                        <v-icon small> more_horiz </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <!-- <v-list-item v-if="canBeApproved1(item)" @click="approveAction(item)">
                        <v-list-item-title> Approve </v-list-item-title>
                      </v-list-item> -->
                      <v-list-item @click="downloadWarrant(item)">
                        <v-list-item-title> Download </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
              </tbody>
            </table>
          </v-card-text>
          <v-card-actions>
            <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="page"
              :length="numberOfLinks"
              :total-visible="7"
              color="secondary"
                class="accent--text logoutbtn"
            ></v-pagination>
          </v-card-actions>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
export default {
  name: 'ncesettlement',
  data: function () {
    return {
      payments: [],
      selectAll: false,
      message: '',
      loading: false,
      snackbar: false,
      snackbarColor: '',
      messsage: '',
      permissions: [],
      paginatedItems: [],
      numberOfLinks: 0,
      numberOfItemsPerPage: 5,
      page: 1,
      search: ''
    }
  },
  watch: {
    payments: function () {
      this.updatePagination()
    },
    page: function (val, oldVal) {
      // Check if the page change was triggered by a user action (e.g., selecting an item)
      if (val !== oldVal) {
        this.paginatedItems = this.paginationMethod(this.payments, val, this.numberOfItemsPerPage)
      }
    }
  },
  mounted () {
    this.getPayments()
    this.numberOfLinks = Math.ceil(this.payments.length / this.numberOfItemsPerPage)
    this.permissions = store.state.user.roleId.permissions
  },
  computed: {
    filteredList: function () {
      if (this.search === '') {
        return this.paginatedItems
      } else {
        return this.payments.filter(payment => {
          const searchTerm = this.search.toLowerCase()
          var dateCreated = new Date(payment.dateCreated)
          return (
            (payment.eslipNumber?.toLowerCase()?.toString() ?? '').includes(searchTerm) ||
            (payment.lotNumber?.toLowerCase()?.toString() ?? '').includes(searchTerm) ||
            (payment.invoiceId?.toString() ?? '').includes(searchTerm) ||
            (payment.cleanCoffeeOutTurn?.toLowerCase() ?? '').includes(searchTerm) ||
            (payment.parchmentOutTurn?.toLowerCase() ?? '').includes(searchTerm) ||
            (payment.growerCode?.toLowerCase() ?? '').includes(searchTerm) ||
            dateCreated.toDateString().toLowerCase().includes(searchTerm)
          )
        })
        // return this.warrants.filter(warrant => { return warrant.outTurnNumber.toLowerCase().includes(this.search.toLowerCase()) })
      }
    },
    allEligibleRecordsSelected () {
      return this.filteredList
        .filter(item => this.canBeApproved1(item))
        .every(item => item.selected)
    }
  },
  methods: {
    paginationMethod (items, pageNumber, limitPerPage) {
      pageNumber = pageNumber - 1
      const from = pageNumber * limitPerPage
      let to = (pageNumber + 1) * limitPerPage
      if (to >= items.length) {
        to = items.length
      }
      return items.slice(from, to)
    },
    updatePagination () {
      this.numberOfLinks = Math.ceil(this.payments.length / this.numberOfItemsPerPage)
      this.paginatedItems = this.paginationMethod(this.payments, this.page, this.numberOfItemsPerPage)
    },
    async getPayments () {
      try {
        const response = await axios.get(config.serverURI + '/nceTransaction/getAll')
        this.payments = response.data
        console.log(this.payments)
        this.totalWarrants = this.payments.length
        this.updatePagination()
      } catch (error) {
        this.handleRequestError(error, 'Error occurred while fetching payments')
      }
    },
    canBeApproved1 (item) {
      return item.warrantNumber != null && item.approver1 == null && this.hasPerm('CAN_CONFIRM_WARRANT')
    },
    canBeApproved2 (item) {
      return item.approver1 != null && item.approver2 == null && this.hasPerm('CAN_CONFIRM_WARRANT')
    },
    hasPerm (permission) {
      return this.permissions.includes(permission)
    },
    onCheckboxChange (item) {
      // Handle checkbox change here
      // Update the paginated items without changing the page
      this.paginatedItems = this.paginationMethod(this.payments, this.page, this.numberOfItemsPerPage)
    },
    selectAllItems () {
      for (const item of this.payments) {
        item.selected = this.selectAll
      }
    },
    approveActionForSelected () {
      const selectedItems = this.filteredList.filter(item => item.selected)
      const selectedItemsArray = []
      // Perform the approval action for selected items
      for (const item of selectedItems) {
        selectedItemsArray.push(item)
      }
      this.approveAction(selectedItemsArray)
    }
  }
}

</script>
<style>
.warrant_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.warrant_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.warrant_box:after, .warrant_box:before {
  right: 100%;
  top: 90%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.warrant_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}
.warrant_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}
</style>
